<mwp-benefit-enrollment-category-header [enrollmentManager]="enrollmentManagerService.manager" />

@if (displayWaiveDocumentPanel) {
  <mwp-benefit-enrollment-checkout-waive-document [checkoutWaiveDocument]="checkoutWaiveDocument" (emitComplete)="completePanel($event)"/>
}
@if (displaySurchargePanel) {
  <mwp-benefit-enrollment-checkout-surcharge [checkoutSurcharge]="checkoutSurcharge" (emitComplete)="completePanel($event)"/>
}
@if (displaySSNPanel) {
  <mwp-benefit-enrollment-checkout-ssn [checkoutDependents]="checkoutDependents" (emitComplete)="completePanel($event)" />
}
@if (displayDependentsVerify) {
  <mwp-benefit-enrollment-checkout-dependent-verify [checkoutDependents]="checkoutDependents" (emitComplete)="completePanel($event)"/>
}
@if (displayDocumentsPanel) {
  <mwp-benefit-enrollment-checkout-documents [checkoutDocuments]="checkoutDocuments" (emitComplete)="completePanel($event)"/>
}
@if (displaySpousalExclusionPanel) {
  <mwp-benefit-enrollment-checkout-spouse-exclusion [checkoutSpousalExclusion]="checkoutSpousalExclusion" (emitComplete)="completePanel($event)"/>
}
@if (displayBeneficiariePanel) {
  <mwp-benefit-enrollment-wizard-beneficiaries [beneficiariesResponse]="beneficiariesResponse"  [isCheckoutWizard]="true" (emitComplete)="completePanel($event)" />
}
@if (displayUSAePayPanel) {
  <mwp-benefit-enrollment-checkout-usa-e-pay [usaEPay]="usaEPay" (emitComplete)="completePanel($event)"/>
}
@if (displayAutoEnrollPanel) {
  <mwp-benefit-enrollment-checkout-auto-enroll [wizardCoverageSummary]="wizardCoverageSummary"  (emitComplete)="completePanel($event)"/>
}
@if (displayAdminEventPanel) {
  <mwp-benefit-enrollment-checkout-admin-event [checkoutAdminEvent]="checkoutAdminEvent" (emitComplete)="completePanel($event)"/>
}
@if (displaySummaryPanel) {
  <mwp-benefit-enrollment-checkout-summary  [benefitSummaryList]="summaryBenefitList" (emitComplete)="completePanel($event)"/>
}
@if (displayFinalizePanel) {
  <mwp-benefit-enrollment-checkout-finalize [checkoutFinalize]="checkoutFinalize" (emitComplete)="completePanel($event)"/> 
}

@if (isLoading) {
  <mwp-placeholder-table [displayButton]="true" />
}
@if (isNotConfigured) {
  <mwp-wizard-error [displayReturnButton]="false" />
}